import DateFnsUtils from "@date-io/date-fns";
import { ThemeProvider } from '@material-ui/styles';
import enUS from "date-fns/locale/en-US";
import es from "date-fns/locale/es";
import ptBR from "date-fns/locale/pt-BR";
import React from "react";
import {
  AuthenticationState, AzureAD
} from "react-aad-msal";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Router from "./components/Routes/Routes";
import theme from './theme';

import { CssBaseline } from "@material-ui/core";
import { authProvider } from "./authProvider";
import AppProvider from "./context/index";
import { basicReduxStore } from "./reduxStore";
import { setHeaderBearerToken } from './services/interceptor.service';

// TODO: Revisar problema da lib ReactPlugin from "@microsoft/applicationinsights-react-js"
// AddApplicationInsights();

const App = ({
  i18n,
  wrapper: {
    spinner: { payload: showSpinner },
  },
}) => {
  const locale = () => {
    switch (i18n.language) {
      case "pt":
        return ptBR;
      case "us":
        return enUS;
      case "es":
        return es;
      default:
        return ptBR;
    }
  };

  setHeaderBearerToken();

  return (
    <ThemeProvider theme={theme.main}>
      <AppProvider>
        <CssBaseline />
        <AzureAD provider={authProvider} reduxStore={basicReduxStore}>
          {
            ({ login, authenticationState }) => {
              switch (authenticationState) {
                case AuthenticationState.Authenticated:
                  return (
                    <Router showSpinner={showSpinner} locale={() => locale()} DateFnsUtils={DateFnsUtils} authProvider={authProvider} i18n={i18n} />
                  );
                case AuthenticationState.Unauthenticated:
                  return (
                    <> {login()}</>
                  );
                case AuthenticationState.InProgress:
                  return (<p>Redirecting waiting...</p>);
              }
            }
          }
        </AzureAD>
      </AppProvider>
    </ThemeProvider>
  );
};

const mapStateToProps = ({ wrapper }) => ({
  wrapper,
});

const AppConnect = connect(mapStateToProps)(App);

export default withTranslation()(AppConnect);
